import { Show } from "solid-js";
import { FiRefreshCw } from "solid-icons/fi";

interface LiveManeuversPollStatusProps {
  active: () => boolean;
}

/**
 * Lower-left indicator while Live Maneuvers polls for new rows (mirrors live map stream badge).
 */
export default function LiveManeuversPollStatus(props: LiveManeuversPollStatusProps) {
  return (
    <Show when={props.active()}>
      <div class="live-maneuvers-poll-status" role="status" aria-live="polite" aria-label="Checking for new maneuvers">
        <FiRefreshCw class="live-maneuvers-poll-status__icon" size={14} aria-hidden="true" />
        <span class="live-maneuvers-poll-status__label">Updating</span>
      </div>
    </Show>
  );
}
